import * as Sentry from '@sentry/vue'

// Шум, который не является багами приложения — фильтруем, чтобы не хоронить реальные ошибки
const IGNORED_ERRORS = [
  // Vue Router: штатные «ошибки» навигации (двойные клики, редиректы в guard'ах)
  'NavigationDuplicated',
  'Avoided redundant navigation',
  /Navigation (cancelled|aborted) from/,
  'Redirected when going from',
  // Устаревшие чанки после деплоя — обрабатываются перезагрузкой страницы (router/index.js)
  /dynamically imported module/,
  'Unable to preload CSS',
  'Importing a module script failed',
  // Офлайн и нестабильная сеть — ожидаемое окружение для касс
  'Network Error',
  'Request aborted',
  'Сервер недоступен',
  'Failed to fetch',
  'Load failed',
  // Firebase в офлайне/на неподдерживаемых браузерах
  'installations/app-offline',
  'installations/not-registered',
  'auth/network-request-failed',
  'messaging/unsupported-browser',
  'Generate Auth Token request failed',
  'remoteconfig/storage-open',
  // Браузерные расширения и инжекты сторонних скриптов
  '_isVue',
  'MetaMask',
  'Clover: Disconnected',
  // Cordova: нативный код firebasex вызывает eval в webview до загрузки JS плагина
  'FirebasePlugin is not defined',
  // Cordova: генерик-лог натива без стека и контекста, плодит issue-группу на каждый вариант текста.
  // Подклассы (TooManyRequests/Network/Auth) под паттерн НЕ попадают — их оставляем как диагностику
  'FirebaseException: An internal error has occurred',
  'xbrowser is not defined',
  'swbrowser is not defined',
  'cross-origin frame',
  'cross-origin object',
  "Failed to read the 'cssRules' property",
  // IndexedDB: приватный режим, нехватка места, закрытие вкладки
  'QuotaExceededError',
  'TransactionInactiveError',
  /closed database|database connection is closing|Indexed Database server lost|Internal error opening database|Database deleted by request of the user/,
  // reject() без значения из confirm-диалогов
  'Non-Error promise rejection captured with value: undefined',
]

// Ошибки из кода расширений, а не нашего бандла
const DENY_URLS = [
  /^chrome-extension:\/\//i,
  /^moz-extension:\/\//i,
  /^safari(-web)?-extension:\/\//i,
]

export function initSentry({ Vue, router }) {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn || import.meta.env.VITE_TEST === 'true') return

  Sentry.init({
    Vue,
    dsn,
    router,
    environment: import.meta.env.VITE_TEST === 'true' ? 'test' : 'production',
    ignoreErrors: IGNORED_ERRORS,
    denyUrls: DENY_URLS,
    integrations: [
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
    ],
  })
}
